<template>
    <div class="main-page-map">
        <YandexMap v-bind="mapSettings" ref="map" @map-was-initialized="onInit">
            <YmapMarker
                v-for="(marker, i) in markers"
                :key="`marker-${i}`"
                v-bind="marker"
                :markerId="`marker-${i}`"
            />
        </YandexMap>

        <div v-if="isMapInited" class="center-block">
            <div class="sidebar-container">
                <div class="box">
                    <div class="box__main">
                        <p class="title">Как добраться</p>

                        <div>
                            <Toggler
                                v-model="togglerModel"
                                :disabled="$wait.waiting('panning')"
                                :yes-string="markers[1].text"
                                :no-string="markers[0].text"
                            />
                        </div>

                        <div class="decription">
                            <SvgIcon :glyph="'map-point'" class="decription__icon" />
                            <div
                                class="user-content"
                                v-html="markers[activeMarker].description"
                            ></div>
                        </div>
                    </div>

                    <div class="box__footer">
                        <Button
                            @click="onBtnClick"
                            :modifiers="['primary', 'rounded']"
                            class="box__btn"
                            >Записаться на встречу</Button
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Toggler from '@/components/Controls/Toggler/Toggler.vue';
import Button from '@/components/Controls/Button/Button.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';

export default {
    name: 'MainPageMap',

    components: {
        Toggler,
        Button,
        SvgIcon,
        YandexMap: () =>
            import(
                /* webpackChunkName: "YandexMap" */
                /* webpackMode: "lazy" */ 'vue-yandex-maps'
            ).then(({ yandexMap }) => yandexMap),
        YmapMarker: () =>
            import(
                /* webpackChunkName: "YandexMap" */
                /* webpackMode: "lazy" */ 'vue-yandex-maps'
            ).then(({ ymapMarker }) => ymapMarker),
    },

    data() {
        return {
            togglerModel: false,
            isMapInited: true,
        };
    },

    computed: {
        mapSettings() {
            const settings = this.$root.rootProps?.settings?.map || {};
            return window.innerWidth < 960
                ? Object.assign({}, settings, {
                      controls: [],
                      detailedControls: {},
                  })
                : settings;
        },
        markers() {
            return this.$root.rootProps?.settings?.markers || [];
        },
        activeMarker() {
            return Number(this.togglerModel);
        },
    },

    methods: {
        async panTo(marker) {
            const map = this.$refs.map.myMap;
            try {
                this.$wait.start('panning');
                await map.panTo([this.markers[marker].coords], {
                    duration: 2000,
                    checkZoomRange: true,
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.$wait.end('panning');
            }
        },

        onInit() {
            this.isMapInited = true;
            // const map = this.$refs.map.myMap;
            // const position = map.getGlobalPixelCenter();
            // map.setGlobalPixelCenter([position[0] - 200, position[1]]);
            // this.$refs.map.myMap.setBounds(
            //     [
            //         [55, 37],
            //         [40, 60],
            //     ],
            //     { checkZoomRange: true }
            // );
        },

        onBtnClick() {
            const $marker = this.markers[this.activeMarker];

            const modalData = this.$enrichVars(this.$root.rootProps?.modalData || {}, {
                $marker,
            });
            window.$feedbackWidget.show(modalData);
        },
    },

    watch: {
        activeMarker(value) {
            this.panTo(value);
        },
    },
};
</script>

<style lang="scss" scoped>
$threshold: 960px;

@mixin height {
    min-height: 500px;
    height: 90px;

    @media (min-width: 1200px) {
        height: 120px;
    }
}

.ymap-container {
    height: 100%;
}

.main-page-map {
    position: relative;
    @include height;
}

.sidebar-container {
    @media (max-width: ($threshold - 1)) {
        position: relative;
    }

    @media (min-width: $threshold) {
        position: absolute;
        width: 0;
        @include height;
    }
}

.center-block {
    position: absolute;
    left: 0;
    right: 0;

    @media (max-width: ($threshold - 1)) {
        bottom: 0;
        padding-left: 8px;
        padding-right: 8px;
    }

    @media (min-width: $threshold) {
        top: 0;
    }
}

.box {
    position: absolute;
    background: var(--accent-gray-0);
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
    border-radius: var(--border-radius-primary);
    z-index: 20;

    @media (max-width: ($threshold - 1)) {
        bottom: 8px;
        width: 100%;
        padding: 20px;
    }

    @media (min-width: $threshold) {
        padding: 30px;
        min-width: 375px;
        top: 0;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    @media (min-width: 560px) and (max-width: ($threshold - 1)) {
        display: flex;
        align-items: center;
    }
}

.box__footer {
    @media (max-width: ($threshold - 1)) {
        text-align: center;
        margin-top: 20px;
    }

    @media (min-width: $threshold) {
        margin-top: 60px;
    }

    @media (min-width: 560px) and (max-width: ($threshold - 1)) {
        margin-top: 0;
    }
}

.box__main {
    flex: 1 0 auto;
}

.box__btn {
    width: 100%;
    @media (max-width: ($threshold - 1)) {
        max-width: 270px;
    }
}

.title {
    font-weight: 600;

    @media (max-width: ($threshold - 1)) {
        margin: 0 0 10px;
        font-size: 17px;
    }

    @media (min-width: $threshold) {
        font-size: 25px;
        line-height: 30px;
        margin-top: 40px;
        margin: 0 0 20px;
    }
}

.decription {
    padding-left: 30px;
    position: relative;

    @media (max-width: ($threshold - 1)) {
        margin-top: 10px;
        font-size: 11px;
        line-height: 15px;
        display: inline-block;
        vertical-align: top;
    }

    @media (min-width: $threshold) {
        margin-top: 20px;
    }
}

.decription__icon {
    position: absolute;
    left: 0;

    @media (max-width: ($threshold - 1)) {
        top: -3px;
    }

    @media (min-width: $threshold) {
        top: 0;
    }
}
</style>
